module.exports = __webpack_public_path__ + "img/plus-circle.365ab9a2.svg";